import { UserModel } from "../../../models/user/user.model";

export enum UserChangeAction {
  JOIN = "JOIN",
  UPDATE = "UPDATE",
  LEAVE = "LEAVE",
  DISCONNECT = "DISCONNECT",
  RECONNECT = "RECONNECT",
}

export type UserChangeModel = {
  action: UserChangeAction;
  user: UserModel;
};
